import { NgModule } from '@angular/core';
import { TreeModule } from 'angular-tree-component';
import { CategoriesComponent } from './components/categories.component';
import { CategoryService } from './services/category.service';
import { CategoryFormComponent } from './components/category-form.component';
import { CreateCategoryModal } from './modals/create/create.modal';
import { EditCategoryModal } from './modals/edit/edit.modal';
import { SupportModule } from '../support/support.module';
import { FormsModule } from '../forms/forms.module';
import { ChassisModalModule } from '../modals/modals.module';

@NgModule({
    imports: [TreeModule, SupportModule, FormsModule, ChassisModalModule],
    declarations: [CategoriesComponent, CreateCategoryModal, EditCategoryModal, CategoryFormComponent],
    entryComponents: [CategoriesComponent, CreateCategoryModal, EditCategoryModal, CategoryFormComponent],
    exports: [TreeModule],
    providers: [CategoryService]
})
export class CategoryModule {

}


// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/categories/category.module.ts